import { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useAccount } from '../../contexts/Account';
import SurveyLinearStat from '../SurveyLinearStat';
import useSurveyViewer from '../../hooks/useSurveyViewer';
import { answerSurveyQuestion } from '../../services/survey_services';
import { addActivityFromAnswerSurvey } from '../../services/utils/surveys';

export default function SurveyStats(props) {
  const { surveyId, emptySurveyAnswer, singleQuestion, setSurveyAnswer } =
    props;
  const [surveyResults, loadingResults] = useSurveyViewer(surveyId);
  const { accountDetails, type } = useAccount();
  const [loading, setLoading] = useState(false);

  async function handleSurveyResponse(surveyResponse) {
    setLoading(true);
    await answerSurveyQuestion({
      BODY: surveyResponse,
      SURVEY_ID: singleQuestion.surveyId,
      SURVEY_QUESTION_ID: singleQuestion.id,
      USER_ACCOUNT_TYPE: type,
      USER_ID: accountDetails.id,
    });
    setLoading(false);
    addActivityFromAnswerSurvey({
      accountDetails,
      surveyAnswer: surveyResponse,
      questionBody: singleQuestion.body,
    });
  }

  return (
    <Box sx={{ height: '100%' }}>
      {surveyResults.map((item, index) => {
        if (emptySurveyAnswer && !loadingResults) {
          return (
            <Button
              variant={'outlined'}
              color="primary"
              onClick={() => {
                setSurveyAnswer(item.body);
                handleSurveyResponse(item.body);
              }}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '14px',
                width: '100%',
                height: '36px',
                borderRadius: '10px',
                margin: '4px 0px',
              }}
              disabled={loading}
            >
              {item.body}
            </Button>
          );
        }
        return (
          <SurveyLinearStat
            key={index}
            optionText={item.body}
            percentage={item.percentage}
            count={item.count}
            loadingResults={loadingResults}
            color={index % 2 === 0 ? '#2B71F6' : '#4FB5F9'}
          />
        );
      })}
    </Box>
  );
}
